import { useMemo } from 'react';
import { getIsHotColdSection } from 'features/hotCold';
import type ISectionSettings from 'types/models/ISectionSettings';

export const useDisplayGames = (data: ISectionSettings, isColdSelected: boolean) => {
  return useMemo(() => {
    if (!getIsHotColdSection(data)) {
      return data.games;
    }

    return isColdSelected ? data.hotColdSettings.coldGames : data.hotColdSettings.hotGames;
  }, [data, isColdSelected]);
};
